// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"SearchCards_resultsWrapper__2nOIx"};